/**
 * In certain usages of StructuredTable, typing in text/formula is disallowed. When trying to look up a
 * cell value, we assert that we are maintaining this invariant.
 *
 * These functions return the contained TypeValue, or null if the cell is empty.
 */
import {assert} from 'Asserts';
import {Cell, TypedValue} from 'notebook/tables/TableConstants';

import {StructuredTable} from '../StructuredTableConstants';

export function getTypedValueFromCell(cell: Cell): TypedValue | null {
  assert(cell != null, 'Cannot get typed value from missing cell');
  assert(!cell.text, 'Cell unexpectedly had non-typedValue persisted', {
    cellText: cell.text,
    cellTypedValue: cell.typedValue,
  });
  return cell.typedValue ?? null;
}

export function getTypedValueFromTable(
  structuredTable: StructuredTable<unknown, unknown>,
  rowIdx: number,
  colIdx: number
): TypedValue | null {
  const cell = structuredTable.rows[rowIdx]?.cells[colIdx];
  assert(cell != null, 'StructuredTable does not have cell at specified position', {
    rowIdx,
    colIdx,
    provenanceUuid: structuredTable.provenanceUuid,
    kind: structuredTable.kind,
    rowCount: structuredTable.rows.length,
    colCount: structuredTable.rows[rowIdx]?.cells.length,
  });
  return getTypedValueFromCell(cell);
}
